// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import formCopy from '../../../../../copy/loginCopy.es';
import Checkmark from 'dibs-vg/dist/react/checkmark';
import UploadFail from 'dibs-vg/dist/react/upload-failed';
import styles from './styles/DealerLoginForm.scss';

type LoginMessageProps = {
    errorMessage?: string,
    messageType?: string,
    successMessage?: string,
};

const LoginMessage = ({ errorMessage, messageType, successMessage }: LoginMessageProps) => {
    const hasErrorMessage = !!errorMessage;
    const message = hasErrorMessage ? errorMessage : successMessage;
    const MessageIcon = hasErrorMessage ? UploadFail : Checkmark;

    if (!message) {
        return null;
    }
    return (
        <div
            className={classNames(styles.messageBanner, {
                [styles.error]: hasErrorMessage,
                [styles.success]: !hasErrorMessage,
            })}
        >
            <MessageIcon
                className={classNames(styles.messageIcon, {
                    [styles.failIcon]: hasErrorMessage,
                    [styles.checkmarkIcon]: !hasErrorMessage,
                })}
            />
            <span className={styles.message}>
                <FormattedMessage {...formCopy.message[messageType]} />
            </span>
        </div>
    );
};

export default LoginMessage;
